<ng-container *ngIf="src">
    <img class="image" [src]="src" *ngIf="!srcset" /> <img class="image" [src]="src" [srcset]="srcset" *ngIf="srcset" />
</ng-container>
<cm-icon class="image" [name]="iconName" *ngIf="!src && iconName"></cm-icon>
<h3 class="title">{{ title }}</h3>
<p class="sub-title" *ngIf="subtitle">{{ subtitle }}</p>
<button class="cm-link" *ngIf="buttonText" (click)="onButtonClick.emit()">{{ buttonText }}</button>
